import { render, staticRenderFns } from "./OverdueInvoicesCard.vue?vue&type=template&id=6d82dbb6&"
import script from "./OverdueInvoicesCard.vue?vue&type=script&lang=js&"
export * from "./OverdueInvoicesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OverdueInvoicesCard.vue"
export default component.exports